var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectboxChevron({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 11,
    viewBox: "0 0 21 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#808080",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,0.5 L10.5,10.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,0.5 L20.5,10.5",
    transform: "matrix(-1 0 0 1 31 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectboxChevron);
export default __webpack_public_path__ + "static/media/selectbox-chevron.046079118fd6466fa812d60bfadcf51c.svg";
export { ForwardRef as ReactComponent };